import { render, staticRenderFns } from "./BulkUploadModal.vue?vue&type=template&id=194585e1&scoped=true"
import script from "./BulkUploadModal.vue?vue&type=script&lang=ts"
export * from "./BulkUploadModal.vue?vue&type=script&lang=ts"
import style0 from "./BulkUploadModal.vue?vue&type=style&index=0&id=194585e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194585e1",
  null
  
)

export default component.exports